import { type } from "skin/event";

export default function refClient(v) {
	type('signup');
	return false;
}